import React from "react";
import PropTypes from "prop-types";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { updateBatchAutoRestart } from "../../axios-client";

function BatchAutoRestartSwitch({
                                    id,
                                    autoRestart,
                                    setAutoRestart,
                                    batchName,
                                    setNotification,
                                }) {
    const handleAutoRestartToggle = async (enabled) => {
        try {
            setAutoRestart(enabled);

            updateBatchAutoRestart(id, enabled)
                .then(() => {
                    setNotification({
                        show: true,
                        snackbarMessage: enabled
                            ? `Automatic batch restart has been successfully activated for batch "${batchName}".`
                            : `Automatic batch restart has been successfully deactivated for batch "${batchName}".`,
                        severity: "success",
                    });
                })
                .catch((e) => {
                    console.error(e);
                    setNotification({
                        show: true,
                        snackbarMessage: "An unexpected error occurred",
                        severity: "error",
                    });
                });
        } catch (error) {
            console.error("Failed to update auto-restart", error);
            setAutoRestart(!enabled);
        }
    };

    return (
        <FormControlLabel
            label="Auto-restart"
            labelPlacement="end"
            sx={{
                margin: 0,
                ".MuiFormControlLabel-label": {
                    fontSize: "0.75rem",
                },
            }}
            control={
                <Switch
                    checked={autoRestart}
                    onChange={(e) => handleAutoRestartToggle(e.target.checked)}
                />
            }
        />
    );
}

BatchAutoRestartSwitch.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    autoRestart: PropTypes.bool,
    setAutoRestart: PropTypes.func.isRequired,
    batchName: PropTypes.string.isRequired,
    setNotification: PropTypes.func.isRequired,
};

export default BatchAutoRestartSwitch;
